module.exports = __webpack_public_path__ + "85447bfba6fca9221359a779cbc38c88.svg";